import type { IntegrationSyncSnapshot } from './marketStatusTone'

export type { IntegrationSyncSnapshot }

const SNAPSHOT_SOURCES = ['TRANS', 'TIMOCOM', 'TELEROUTE', 'ECONTAINERS']

const buildSpotSyncSnapshot = (
  data: Record<string, unknown> | null | undefined,
  options: { requiresActiveToken?: boolean } = {}
): IntegrationSyncSnapshot => {
  const enabled = Boolean(data?.enabled)
  const configured = Boolean(data?.configured)
  const tokenStatus = String(data?.tokenStatus || '').toLowerCase()
  const automationEligible = Boolean(data?.automationEligible)
  const automationReasonKey = String(data?.automationReasonKey || '').trim()
  const hasConfigurationError =
    automationReasonKey === 'trans.errors.oauthClientMisconfigured' ||
    automationReasonKey === 'trans.errors.oauthWrongTokenEndpoint' ||
    tokenStatus === 'client_misconfigured' ||
    tokenStatus === 'wrong_token_endpoint'
  const requiresAttention =
    Boolean(options.requiresActiveToken) &&
    enabled &&
    configured &&
    !automationEligible &&
    automationReasonKey !== ''

  return {
    enabled,
    configured,
    warning: requiresAttention && !hasConfigurationError,
    forceOffline: requiresAttention && hasConfigurationError,
  }
}

// Snapshoty integracji przychodzą w polu `integrations` odpowiedzi /api/marketplaces/status
// (jedno żądanie zamiast pięciu). Brak pola (backend sprzed rolloutu) = brak snapshotów —
// pigułki idą wtedy za samym statusem, bez ostrzeżeń Trans; to stan przejściowy, nie błąd.
export const buildIntegrationSync = (
  integrations: Record<string, unknown> | null | undefined,
  visibleSources: string[]
): Record<string, IntegrationSyncSnapshot> => {
  const nextSync: Record<string, IntegrationSyncSnapshot> = {}
  if (!integrations || typeof integrations !== 'object') {
    return nextSync
  }
  for (const key of SNAPSHOT_SOURCES) {
    if (!visibleSources.includes(key)) continue
    const data = integrations[key]
    if (!data || typeof data !== 'object') continue
    nextSync[key] = buildSpotSyncSnapshot(data as Record<string, unknown>, {
      requiresActiveToken: key === 'TRANS',
    })
  }
  return nextSync
}
